<template lang="pug">
  .pagination.d-flex.justify-content-center
    .page.p-2(v-for="page in pages" :key="page" @click="jumpTo(page)"
    :class="{ 'text-dark': current === page, 'pointer-cursor text-light': current !== page }")
      | {{ page + 1 }}
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    totalPage: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      current: 0,
    };
  },
  computed: {
    pages() {
      const pages = [...Array(this.totalPage).keys()];
      if (this.current < 3) {
        return pages.slice(0, 5);
      }
      if (this.current > (this.totalPage - 3)) {
        return pages.slice(Math.max(this.totalPage - 5, 0), this.totalPage);
      }
      return pages.slice(this.current - 2, this.current + 3);
    },
  },
  methods: {
    init() {
      this.current = 0;
    },
    jumpTo(page) {
      this.current = page;
      this.$emit('jumpTo', page);
    },
  },
};
</script>

<style lang="sass" scoped>
.pagination
  .page:not(:first-child)
    margin-left: 8px

  .page
    font-size: 14px
</style>
